export default __webpack_public_path__ + "static/media/PaperClip.14527ca4.svg";